export type FontScalePreset = 'small' | 'default' | 'large' | 'extraLarge';

export const FONT_SCALE_VALUES: Record<FontScalePreset, number> = {
  small: 0.875,
  default: 1,
  large: 1.125,
  extraLarge: 1.25,
};

export const FONT_SCALE_LABELS: Record<FontScalePreset, string> = {
  small: 'Small',
  default: 'Default',
  large: 'Large',
  extraLarge: 'Extra large',
};

export const FONT_SCALE_PRESETS: FontScalePreset[] = [
  'small',
  'default',
  'large',
  'extraLarge',
];

const VALID_PRESETS = new Set<string>(FONT_SCALE_PRESETS);

export function parseFontScalePreset(value: string | null): FontScalePreset {
  if (value && VALID_PRESETS.has(value)) {
    return value as FontScalePreset;
  }
  return 'default';
}
